import './content-elements/slide'
import './content-elements/zoom-img'
import './content-elements/fade'
import './content-elements/counter'
import './content-elements/navbar'
import './content-elements/form'
import './content-elements/animations'
import './content-elements/disclaimer'

// add variable for app height
const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

// open URL on select field change
const dataOpenUrl = document.querySelectorAll('[data-open-url]')
dataOpenUrl.forEach((item) => {
    const field = item as HTMLFormElement

    // on change open value of option as URL
    field.addEventListener('change', (e) => {
        window.location.href = field.value
    })
})
